import { idSchema } from '@/lib/utils'
import z from 'zod/v4'

export const userSchema = z.object({ userId: idSchema('user') })

export const userFormSchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(255, 'Name must be less than 255 characters'),
  email: z
    .email('Please enter a valid email address')
    .max(255, 'Email must be less than 255 characters'),
  roles: z.string().optional(),
})
